// JavaScript to handle subcategory panel hover
document.addEventListener("DOMContentLoaded", () => {
  const mainCategoryItems = document.querySelectorAll(
    ".shopall-main-categories-list li"
  );
  const subcategoryPanels = document.querySelectorAll(
    ".shopall-subcategories-panel"
  );

  mainCategoryItems.forEach((item) => {
    const link = item.querySelector(".shopall-main-category-link");
    const mainCategory = link.getAttribute("data-main-category");
    const targetPanel = document.getElementById(
      `ShopAll-Subcategories-${mainCategory}`
    );

    item.addEventListener("mouseenter", () => {
      // Hide all panels
      subcategoryPanels.forEach((panel) => {
        panel.style.display = "none";
      });
      // Show the corresponding panel
      if (targetPanel) {
        targetPanel.style.display = "block";
      }
    });
  });

  // Keep panel visible when hovering over it
  subcategoryPanels.forEach((panel) => {
    panel.addEventListener("mouseenter", () => {
      panel.style.display = "block";
    });
    panel.addEventListener("mouseleave", () => {
      panel.style.display = "none";
      // Show the first panel again
      const firstPanel = document.querySelector(
        ".shopall-subcategories-panel:first-child"
      );
      if (firstPanel) {
        firstPanel.style.display = "block";
      }
    });
  });
});
